import {useFieldArray, useFormContext} from "react-hook-form";
import {newSpellGroup} from "@/characters/admin/form/CharacterFormSchema.ts";
import {FormField, FormItem, FormMessage} from "@/components/ui/form.tsx";
import SpellGroupItemView from "@/characters/admin/form/SpellGroupItemView.tsx";
import {Button} from "@/components/ui/button.tsx";
import {Plus} from "lucide-react";
import {CharacterFormInput} from "@/characters/admin/form/CharacterFormSchema.ts";

export default function SpellGroupView() {
    const {control} = useFormContext<CharacterFormInput>();
    const spellGroupArray = useFieldArray({control, name: "spellcasting.spellGroups"});

    const addSpellGroup = () => spellGroupArray.append(newSpellGroup(spellGroupArray.fields.length))

    return <>
        <div className="flex flex-wrap items-center justify-between gap-3 border-t pt-3">
            <div>
                <div className="font-semibold">Zaubergruppen</div>
                <p className="text-sm text-muted-foreground">Die Reihenfolge wird in der Charakteransicht übernommen.</p>
            </div>
            <Button type="button" size="sm" variant="outline" onClick={addSpellGroup}>
                <Plus/> Zaubergruppe hinzufügen
            </Button>
        </div>
        <FormField name="spellcasting.spellGroups" render={() => (
            <FormItem className="space-y-2">
                <FormMessage/>
                {spellGroupArray.fields.length === 0 && (
                    <div className="rounded-lg border border-dashed p-4 text-center text-sm text-muted-foreground">
                        Noch keine Zaubergruppen vorhanden.
                    </div>
                )}
                {spellGroupArray.fields.map((field, index) =>
                    <SpellGroupItemView key={field.id} groupIndex={index} spellGroupArray={spellGroupArray}/>)
                }
            </FormItem>
        )}/>
    </>;
}
